import { queryOptions } from "@tanstack/react-query";

import { clientsApi } from "../lib/api";

export const clientsQueryKey = ["clients"] as const;

const clientsPickerQueryKey = [...clientsQueryKey, "picker"] as const;

export const clientsPickerQueryOptions = queryOptions({
  queryKey: clientsPickerQueryKey,
  queryFn: () => clientsApi.list({ limit: 60 }),
});

export const clientsAllQueryOptions = queryOptions({
  queryKey: [...clientsQueryKey, "all"],
  queryFn: () => clientsApi.listAll(),
});
